<template>
  <div class="distributor-card-wrapper">
    <div class="distributor-card">
      <div class="logo" :style="[distributor.logo !== null ? {'background-image': 'url(' + distributor.logo + ')'} : '']"></div>
      <div class="content">
        <h2><a :href="distributor.url">{{ distributor.name }}</a></h2>
        <p v-if="distributor.display_address.length" v-html="distributor.display_address"></p>
        <p v-if="distributor.office_phone_plain.length"><a :href="'tel:+1' + distributor.office_phone_plain">{{ distributor.office_phone }}</a></p>
        <p v-if="distributor.other_phone_plain.length"><a :href="'tel:+1' + distributor.other_phone_plain">{{ distributor.other_phone }}</a></p>
        <p v-if="distributor.email.length"><a :href="'mailto:' + distributor.email">{{ distributor.email }}</a></p>
        <p v-if="distributor.website.length"><a :href="distributor.website">{{ distributor.website }}</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DistributorCard',
  props: {
    distributor: Object
  }
}
</script>
